module.exports = __webpack_public_path__ + "media/coffee-preferences/equitable_trade_fifty_percent_of_my_section-aeb3570a.png";